import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { User } from "../../services/user";
import { Api } from "../../services/api";
import { Util } from "../../services/util";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "login",
})
@Component({
  selector: "page-login",
  templateUrl: "login.html",
})
export class LoginPage {
  formData = {
    mobile: "",
    countDown: 0,
    step: 0,
    verificationCode: "",
  };

  countdownTimer = null;

  ionViewDidEnter() {
    this.countdownTimer = setInterval(() => {
      this.formData.countDown--;
    }, 1000);
  }

  ionViewWillUnload() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public user: User,
    public api: Api,
    public util: Util
  ) {}

  requestVerificationCode() {
    this.api.requestLoginVerificationCode(this.formData).then((data) => {
      if (data["ok"]) {
        this.formData.countDown = 60;
        this.formData.step = 1;
      }
    });
  }

  doLogin() {
    this.api.doLoginByVerificationCode(this.formData).then((data) => {
      if (data["ok"]) {
        this.util.showToast("登入成功");
        this.user.setToken(data["token"]);

        let url =
          sessionStorage["nonWechatLoginCallbackUrl"] ||
          window.location.origin + "/?s=wx#/my-campaigns";
        if (url.indexOf(`#/login`) >= 0) {
          url = window.location.origin + "/?s=wx#/my-campaigns";
        }
        setTimeout(() => {
          window.location.assign(url);
        }, 300);
        delete sessionStorage["nonWechatLoginCallbackUrl"];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts